import React, { useState, useEffect } from 'react';
import { Menu, X, Download } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleDownloadPDF = () => {
    setIsMobileMenuOpen(false);
    // Give browsers a tick so any open menu collapses before the print dialog appears.
    // ExperienceSection listens to the native 'beforeprint' event to expand all cards.
    setTimeout(() => window.print(), 50);
  };

  const navItems = [
    { label: 'About', section: 'about' },
    { label: 'Experience', section: 'experience' },
    { label: 'Skills', section: 'skills' },
    { label: 'Projects', section: 'projects' },
    { label: 'Blog', section: 'blog' },
    { label: 'Open Source', section: 'open-source' },
    { label: 'Contact', section: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0f1419]/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-end items-center h-16">
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.section}
                onClick={() => scrollToSection(item.section)}
                className="px-4 py-2 text-gray-300 hover:text-emerald-400 transition-colors duration-200 text-sm font-medium"
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={handleDownloadPDF}
              data-testid="download-pdf-btn"
              className="ml-2 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-medium px-4 py-2 h-auto rounded-md transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/30 flex items-center gap-2"
            >
              <Download size={16} />
              Download PDF
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#1a1d29] border-t border-gray-800">
          <nav className="flex flex-col px-4 py-4 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.section}
                onClick={() => scrollToSection(item.section)}
                className="text-left px-4 py-2 text-gray-300 hover:text-emerald-400 hover:bg-gray-800/50 rounded transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={handleDownloadPDF}
              data-testid="download-pdf-btn-mobile"
              className="flex items-center gap-2 text-left px-4 py-2 mt-1 text-emerald-400 hover:bg-emerald-500/10 rounded transition-colors duration-200 font-medium"
            >
              <Download size={16} />
              Download PDF
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
